
import { Component, Vue } from "vue-property-decorator";
import { Action, Mutation, State } from "vuex-class";
import Link from "@/components/Link.vue";
import BackButton from "@/components/BackButton.vue";
import ColorScaleCompService from '@/services/ColorScaleComp.service';

const namespace = "BookModule";

@Component({
  components: {
    Link,
    BackButton
  }
})

export default class HLColorSpace extends Vue{
  @Action('fetchData', { namespace }) private fetchData!: () => any;
  @Mutation('setSliderHue', {namespace}) private setSliderHue!: (value:number) => any;
  @Mutation('setSliderLuminance', {namespace}) private setSliderLuminance!: (value:number) => any;
  @Mutation private setPreviousPage!: (name: string) => any;
  @Mutation private setCurrentPage!: (name: string) => any;
  @State('sliderHue', { namespace }) private sliderHue!: number;
  @State('sliderLuminance', { namespace }) private sliderLuminance!:  number;
  
  @State private previousPage!: string;
  @State private currentPage!: string;

  private mounted(){
    if(this.$route.name!=null){
      this.setPreviousPage(this.currentPage);
      this.setCurrentPage(this.$route.name);
    }
  }
  
  private async created(){
    await this.fetchData();
  }

  private handleHueSlider(event:any){
    this.setSliderHue(parseInt(event.target.value));
  }

  private handleLuminanceSlider(event:any){
    this.setSliderLuminance(event.target.value);
  }

  private getColor() : string {
    return ColorScaleCompService.HLtoHEX(this.sliderHue, this.sliderLuminance);
  }
};
